import React from 'react';
import { ScrollView } from 'react-native';
import View from '../../components/styled/View';
import { Formik } from 'formik';
import { loginValidationSchema } from './validationSchema';
import ContainedButton from '../../components/styled/ContainedButton';
import EmailInput from '../../components/styled/EmailInput';
import ErrorText from '../../components/styled/ErrorText';
import PasswordInput from '../../components/styled/PasswordInput';
import HeaderOne from '../../components/styled/HeaderOne';
import HeaderTwo from '../../components/styled/HeaderTwo';
import LinearGradientButton from '../../components/styled/LinearGradientButton';
import Link from '../../components/styled/Link';
import Logo from '../../components/styled/Logo';
import styles from './styles';

const SignInScreen = ({
  navigation,
  signInError,
  signInLoading,
  signInUser,
}) => {
  return (
    <ScrollView contentContainerStyle={styles.scrollViewContainer}>
      <View style={styles.container}>
        <View style={styles.logo}>
          <Logo />
        </View>
        <View style={styles.headers}>
          <HeaderOne title="Welcome!" />
          <HeaderTwo title="Sign In" />
        </View>
        <Formik
          initialValues={{ email: '', password: '' }}
          onSubmit={(values) => signInUser(values)}
          validationSchema={loginValidationSchema}
        >
          {({
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            isValid,
            touched,
            values,
          }) => (
            <>
              <View>
                <EmailInput
                  errorMessage={touched.email && errors.email}
                  onBlur={handleBlur('email')}
                  onChangeText={handleChange('email')}
                  value={values.email}
                />
                <PasswordInput
                  errorMessage={touched.password && errors.password}
                  onBlur={handleBlur('password')}
                  onChangeText={handleChange('password')}
                  value={values.password}
                />
                <View style={styles.link}>
                  <Link
                    onPress={() => navigation.navigate('ForgotPassword')}
                    text="Forgot password?"
                  />
                </View>
                <View style={styles.signIn}>
                  <LinearGradientButton
                    loading={signInLoading}
                    disabled={!isValid || signInLoading}
                    title="Sign In"
                    onPress={handleSubmit}
                  />
                  <>{signInError && <ErrorText text={signInError} />}</>
                </View>
              </View>
            </>
          )}
        </Formik>
        <View style={styles.createAccount}>
          <ContainedButton
            onPress={() => navigation.navigate('SignUp')}
            title="Create Account"
            style={{ width: 250 }} // FIXME: THIS IS A HACK FIX ME
          />
        </View>
      </View>
    </ScrollView>
  );
};

export default SignInScreen;
